// extracted by mini-css-extract-plugin
export default {"container":"Tints_container__BoE3c","wrap":"Tints_wrap__Gk1cZ","tint":"Tints_tint__aFPB2","color":"Tints_color__8eRJ6","label":"Tints_label__QSrWd"};